const styles = {
  list: {
    padding: 0,
  },
};

export default styles;
